import { Label } from '~/components/ui/label';
import { Checkbox } from '~/components/ui/checkbox';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '~/components/ui/card';

interface Acknowledgments {
  infoAccurate?: boolean;
  understandPolicy?: boolean;
}

interface AcknowledgmentsChunkProps {
  acknowledgments: Acknowledgments;
  onUpdate: (acknowledgments: Acknowledgments) => void;
  isApplication?: boolean;
}

/**
 * Reusable acknowledgments checkboxes.
 * Used by both reenrollment ReviewStep and application AppReviewStep.
 */
export function AcknowledgmentsChunk({
  acknowledgments,
  onUpdate,
  isApplication: _isApplication = false,
}: AcknowledgmentsChunkProps) {
  const handleChange = (field: string, checked: boolean) => {
    onUpdate({
      ...acknowledgments,
      [field]: checked,
    });
  };

  // TODO: May want different wording for admissions vs reenrollment in the future.
  // Admissions alternative: "I understand the admissions process and that submitting
  // this application does not guarantee enrollment. The school will review our
  // application and contact us regarding next steps."
  const policyText = "I understand that submitting this form is a confirmation of intent to enroll and that I will receive an enrollment packet to complete the enrollment process.";

  return (
    <Card className="border-primary/20">
      <CardHeader className="pb-3">
        <CardTitle className="text-base">Acknowledgments</CardTitle>
        <CardDescription>
          Please confirm the following before submitting
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-start space-x-3">
          <Checkbox
            id="infoAccurate"
            checked={acknowledgments.infoAccurate || false}
            onCheckedChange={(checked) => handleChange('infoAccurate', checked as boolean)}
          />
          <Label
            htmlFor="infoAccurate"
            className="cursor-pointer text-sm leading-relaxed"
          >
            I certify that all information provided is accurate and complete to the best of my knowledge.
          </Label>
        </div>
        <div className="flex items-start space-x-3">
          <Checkbox
            id="understandPolicy"
            checked={acknowledgments.understandPolicy || false}
            onCheckedChange={(checked) => handleChange('understandPolicy', checked as boolean)}
          />
          <Label
            htmlFor="understandPolicy"
            className="cursor-pointer text-sm leading-relaxed"
          >
            {policyText}
          </Label>
        </div>
      </CardContent>
    </Card>
  );
}
